<template>
  <div>
    <div class="d-flex align-center">
      <back-btn />
      <h3 class="title-page ml-3">
        {{ $t("permissions") }} / {{ this.roles[0]?.name }}
      </h3>
    </div>

    <div class="reference_type_page permission">
      <div class="admin_container">
        <div class="text-right mb-5">
          <v-btn @click="editItem('add')" color="primary" dark>
            {{ $t("create") }}
          </v-btn>
        </div>
        <table-with-filter
          :isFilterable="false"
          fixed-header
          handler-value="parent"
          child-key="items"
          :headers="headers"
          :items="permissions"
          :page="configuration.page"
        >
          <template #expandBtn="{ item, openHandler }">
            <triangle-btn
              :loading="item.loading"
              :active="item.show"
              @click="openHandler(item)"
            ></triangle-btn>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip nudge-top="35" nudge-right="10" color="#fff" left>
              <template v-slot:activator="{ on, attrs }">
                <!--If you add to 'btn_33' element 'disabled' class. it is disabled element  -->
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  class="new_style"
                  @click="editItem('update', item)"
                >
                  <vue-icon icon="newPencilIcon" />
                </v-btn>
              </template>
              <span>{{ $t("edit") }}</span>
            </v-tooltip>
            <v-tooltip nudge-top="35" nudge-right="10" color="#fff" left>
              <template v-slot:activator="{ on, attrs }">
                <!--If you add to 'btn_33' element 'disabled' class. it is disabled element  -->
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  class="new_style"
                  @click="editItem('delete', item)"
                >
                  <vue-icon icon="newTrashIcon" />
                </v-btn>
              </template>
              <span>{{ $t("delete") }}</span>
            </v-tooltip>
          </template>
          <template v-slot:child.actions="{ item, header, child }">
            <v-tooltip nudge-top="35" nudge-right="10" color="#fff" left>
              <template v-slot:activator="{ on, attrs }">
                <!--If you add to 'btn_33' element 'disabled' class. it is disabled element  -->
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  class="new_style"
                  @click="editItem('update', child, item.code)"
                >
                  <vue-icon icon="newPencilIcon" />
                </v-btn>
              </template>
              <span>{{ $t("edit") }}</span>
            </v-tooltip>
            <v-tooltip nudge-top="35" nudge-right="10" color="#fff" left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  class="new_style"
                  @click="editItem('delete', child)"
                >
                  <vue-icon icon="newTrashIcon" />
                </v-btn>
              </template>
              <span>{{ $t("delete") }}</span>
            </v-tooltip>
          </template>
          <template #item.parent="{ item }"> {{ item.name }}</template>
          <template #item.name>
            <span></span>
          </template>
          <template
            v-for="role in roles"
            v-slot:[`item.${role.code}`]="{ item, header }"
          >
            <role-checkbox
              :key="`roleCheckbox-${role.code}`"
              :items="item.roles"
              @change="(val) => changeRoleState(item, header, val)"
              :ref="`${item.code}-${header.value}`"
              :value="header.value"
            />
          </template>
          <template
            v-for="role in roles"
            v-slot:[`child.${role.code}`]="{ child, header }"
          >
            <role-checkbox
              :key="`childRoleCheckbox-${role.code}`"
              :items="child.roles"
              @change="(val) => changeRoleState(child, header, val)"
              :ref="`${child.code}-${header.value}`"
              :value="header.value"
            />
          </template>

          <template
            v-for="role in roles"
            v-slot:[`header.${role.code}`]="{ header }"
          >
            <div
              class="permission-checkbox-header"
              v-bind:key="`allRoleCheckboxHeader-${role.code}`"
            >
              <role-checkbox
                :key="`allRoleCheckbox-${role.code}`"
                :items="rolesAllOfChecked"
                :ref="`${header.code}-${header.value}`"
                @change="(val) => changeAllRoleState(header, val, role.id)"
                :value="role.code"
              />
              <span>{{ $t("all") }}</span>
            </div>
          </template>
        </table-with-filter>
        <v-pagination
          :total-visible="10"
          v-if="configuration.lastPage > 1"
          @input="getPermissions"
          v-model="configuration.page"
          :length="configuration.lastPage"
        ></v-pagination>
      </div>

      <!--        modals-->
      <v-dialog v-model="dialog" max-width="500px">
        <ValidationObserver v-slot="{ handleSubmit }" ref="form">
          <v-form @submit.prevent="handleSubmit(save)">
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
                <v-icon @click="dialog = false" class="info_modal_close"
                  >mdi-close
                </v-icon>
              </v-card-title>

              <v-card-text>
                <div class="edit_user_table">
                  <CustomInputText
                    rules="required"
                    v-model="editedItem.name"
                    :label="`${$t('name')}*`"
                  ></CustomInputText>
                </div>
                <div class="edit_user_table">
                  <CustomInputText
                    rules="required"
                    v-model="editedItem.code"
                    :label="`${$t('code')}*`"
                  ></CustomInputText>
                </div>
                <div class="edit_user_table">
                  <custom-select
                    :label="$t('parent')"
                    item-value="code"
                    v-model="editedItem.parentCode"
                    :items="permissions"
                  ></custom-select>
                </div>
              </v-card-text>

              <v-card-actions class="footer_modal_user">
                <v-spacer></v-spacer>
                <v-btn color="#9EABBE" dark @click="close"
                  >{{ $t("toCancel") }}
                </v-btn>
                <v-btn color="primary" dark type="submit"
                  >{{ $t("save") }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </ValidationObserver>
      </v-dialog>
      <warning-dialog
        v-model="deleteModal"
        @apply="deleteItem"
      ></warning-dialog>
    </div>
  </div>
</template>

<script>
import WarningDialog from "../../../components/ui/prompt/warning-dialog";
import RoleCheckbox from "@/components/reference/permission/RoleCheckbox";
import TriangleBtn from "@/components/table-with-children/triangleBtn";
import TableWithFilter from "@/components/ui/table/TableWithFilter";
import BackBtn from "@/components/ui/BackBtn.vue";

export default {
  components: {
    BackBtn,
    TableWithFilter,
    TriangleBtn,
    WarningDialog,
    RoleCheckbox,
  },
  data: () => ({
    dialog: false,
    deleteModal: false,
    permissions: [],
    rolesAllOfChecked: [],
    roles: [],
    editedItemId: null,
    editedItem: {
      name: "",
      code: "",
      parentCode: null,
    },
    configuration: {
      lastPage: 0,
      page: 1,
      limit: 10,
    },
  }),

  computed: {
    headers() {
      return [
        {
          text: this.$t("parent"),
          value: "parent",
        },
        {
          text: this.$t("name"),
          value: "name",
        },
        {
          text: this.$t("code"),
          value: "code",
        },
        { text: "", value: "actions", sortable: false },
      ];
    },
    formTitle() {
      return this.editedItemId ? this.$t("edit") : this.$t("create");
    },
  },

  watch: {
    dialog(val) {
      if (!val) {
        const { form } = this.$refs;
        this.editedItem = {
          name: "",
          code: "",
          parentCode: null,
        };
        this.editedItemId = null;
        if (form) form.reset();
      }
    },
  },

  methods: {
    toggleAllRoles(roles = this.roles, permissions = this.permissions) {
      roles.forEach((role) => {
        const isAllChecked = () => {
          const checkList = [];
          const trueChecker = (value) => value === true;
          permissions.forEach((permission) => {
            checkList.push(permission.roles.includes(role.code));
            if (permission.items) {
              permission.items.forEach((child) => {
                checkList.push(child.roles.includes(role.code));
              });
            }
          });
          return checkList.every(trueChecker);
        };
        const value = isAllChecked();
        if (value) {
          if (!this.rolesAllOfChecked.includes(role.code)) {
            this.rolesAllOfChecked.push(role.code);
          }
        } else {
          this.rolesAllOfChecked = this.rolesAllOfChecked.filter(
            (item) => item !== role.code
          );
        }
      });
    },
    clearModal() {
      this.editedItem = {
        name: "",
      };
    },
    editItem(type, item, parentCode) {
      if (type === "add") {
        this.dialog = true;
      } else if (type === "update") {
        this.editedItemId = item.id;
        this.editedItem = { ...item };
        if (parentCode) this.editedItem.parentCode = parentCode;
        this.dialog = true;
      } else if (type === "delete") {
        this.editedItem = item;
        this.deleteModal = true;
      }
    },

    close() {
      this.dialog = false;
    },

    async deleteItem() {
      try {
        const { id } = this.editedItem;
        await this.$http.delete("permission/delete", { params: { id } });
        await this.getPermissions();
        this.setSuccess({ text: this.$t("successfullyDeleted") });
      } catch (e) {
        this.setResponseError({
          error: e,
        });
      }
    },
    async getRole() {
      try {
        const {
          data: { data },
        } = await this.$http.get("role/list", {
          params: { code: this.$route.query.code },
        });
        const [role] = data;
        return role;
      } catch (e) {
        this.setResponseError({ error: e });
      }
    },
    async save() {
      const { name, code, parentCode } = this.editedItem;
      const formData = { name, code };
      if (parentCode) formData.parentCode = parentCode;
      try {
        this.showLoading();
        await this.$http.post("permission/save", formData);
        await this.getPermissions();
        this.dialog = false;
        this.clearModal();
        this.setSuccess({ text: this.$t("successfullySaved") });
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    async changeRoleState(permission, header, { value, role }) {
      let el = this.$refs[`${permission.code}-${header.value}`];
      if (el) {
        el[0].setLoading(true);
      }
      try {
        await this.$http.post("permission/bindToRole", {
          add: value,
          role,
          permission: permission.code,
        });
        if (value) {
          permission.roles.push(role);
        } else {
          permission.roles = permission.roles.filter((item) => item !== role);
        }

        this.setSuccess({ text: this.$t("successfullySaved") });
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.toggleAllRoles();
        if (el) {
          el[0].setLoading(false);
        }
      }
    },
    async changeAllRoleState(header, { value, role }, roleId) {
      const el = this.$refs[`${header.code}-${header.value}`];

      if (el) {
        el[0].setLoading(true);
      }
      try {
        await this.$http.post("permission/bindAllToRole", {
          add: value,
          roleId,
        });
        if (value) {
          this.rolesAllOfChecked.push(role);
        } else {
          this.rolesAllOfChecked = this.rolesAllOfChecked.filter(
            (item) => item !== role
          );
        }
        debugger;
        const newRole = await this.getRole();
        if (newRole) {
          this.roles.push(newRole);
        }
        await this.getPermissions();
        this.setSuccess({ text: this.$t("successfullySaved") });
        if (el) {
          el[0].setLoading(false);
        }
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.toggleAllRoles();
      }
    },
    async getPermissions() {
      const { page, limit } = this.configuration;
      const params = {
        page: page - 1,
        limit,
      };
      try {
        const {
          data: { data: permissions },
        } = await this.$http.get("permission/list", { params });
        const filteredPermissions = permissions.filter(
          (permission) => permission.code !== "REFERENCE_COLUMN"
        );
        this.permissions = filteredPermissions.map((item) => {
          item.show = true;
          return item;
        });
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
  },
  async created() {
    this.showLoading();
    if (this.$route.query.code) {
      const role = await this.getRole();
      if (role) {
        this.headers.push({
          text: role.name,
          value: role.code,
        });
      }
      this.roles.push(role);
    }

    await this.getPermissions();
    this.toggleAllRoles();
    this.clearLoading();
  },
};
</script>

<style lang="scss">
//.reference_type_page.admin_main.permission {
//  table > tbody > tr > td:nth-child(1),
//  table > thead > tr > th:nth-child(1) {
//    position: sticky !important;
//    left: 0;
//    z-index: 2;
//    background: white;
//  }
//
//  table > thead > tr > th:nth-child(1) {
//    z-index: 3;
//  }
//}

.permission-checkbox-header {
  display: flex;
  gap: 3px;
}
</style>
